import React from "react";
import { useTranslation } from "react-i18next";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../common/hooks/hooks";
import { resetFilters } from "../../../productSlice";
import { selectAreFiltersActive } from "../../../productSelectors";
import SearchFilter from "./SearchFilter";
import OnSaleFilter from "./OnSaleFilter";
import InStockFilter from "./InStockFilter";
import CategoryFilter from "./CategoryFilter";
import TagFilter from "./TagFilter";
import BrandFilter from "./BrandFilter";
import PriceFilter from "./PriceFilter";
import AttributeFilter from "./AttributeFilter";

interface FilterSidebarProps {
  idPrefix: string;
}

const FilterSidebar: React.FC<FilterSidebarProps> = ({ idPrefix }) => {
  const dispatch = useAppDispatch();
  const { t, ready: areTranslationsReady } = useTranslation();

  // Use the selector to get the boolean value directly
  const areFiltersActive = useAppSelector(selectAreFiltersActive);

  const handleClearAll = () => {
    dispatch(resetFilters());
  };

  return (
    <div className="filter-sidebar">
      <div className="filter-sidebar__header">
        {areTranslationsReady && (
          <>
            <h2 className="filter-sidebar__title">
              {t("productsArchive.sidebar.filtersTitle")}
            </h2>
            {/* Conditionally render the button using the selector's result */}
            {areFiltersActive && (
              <button
                className="filter-sidebar__clear-btn"
                onClick={handleClearAll}
              >
                {t("productsArchive.sidebar.clearAll")}
              </button>
            )}
          </>
        )}
      </div>
      <div className="filter-sidebar__widgets">
        <div className="filter-widget--bordered">
          <SearchFilter idPrefix={idPrefix} />
        </div>

        <InStockFilter idPrefix={idPrefix} />
        <div className="filter-widget--bordered">
          <OnSaleFilter idPrefix={idPrefix} />
        </div>

        <div className="filter-widget--bordered">
          <CategoryFilter idPrefix={idPrefix} />
        </div>

        <div className="filter-widget--bordered">
          <PriceFilter />
        </div>

        <TagFilter />
        {/* <AttributeFilter /> */}
        {/* <BrandFilter /> */}
      </div>
    </div>
  );
};

export default FilterSidebar;
